"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordRules = exports.forgotPasswordRules = void 0;
const validators_1 = require("@vuelidate/validators");
exports.forgotPasswordRules = {
    username: {
        required: validators_1.required,
        valid: (value) => !!value && /[A-Za-z]/.test(value.trim())
    },
    dateOfBirth: {
        required: validators_1.required,
        valid: (value) => {
            if (!/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(value))
                return false;
            const [month, day, year] = value.split('/').map((value) => { var _a; return (_a = parseInt(value)) !== null && _a !== void 0 ? _a : 1; });
            const dateOfBirth = new Date(year, month - 1, day);
            const today = new Date();
            const isFutureDate = dateOfBirth > today;
            if (isFutureDate)
                return false;
            return (dateOfBirth.getMonth() === month - 1
                && dateOfBirth.getDate() === day
                && dateOfBirth.getFullYear() === year);
        },
    }
};
const passwordRules = (username, credentials) => {
    return {
        password: {
            required: validators_1.required,
            minLength: (0, validators_1.minLength)(8),
            maxLength: (0, validators_1.maxLength)(25),
            hasNumber: validators_1.helpers.regex(/\d/),
            noDisallowedSpecialChar: (value) => !/[^a-zA-Z0-9~!@#%^&$()_{}|.?]/.test(value),
            differentFromUsername: (value) => value.toLowerCase() !== username.value.toLowerCase()
        },
        confirmPassword: {
            required: validators_1.required,
            passwordsMatch: (value) => value !== '' && value === credentials.password
        }
    };
};
exports.passwordRules = passwordRules;
//# sourceMappingURL=password-validation-rules.js.map